import React from "react";

interface ListRootProps {
  children: React.ReactNode;
}

export const ListRoot = ({ children }: ListRootProps) => {
  return <div>{children}</div>;
};
